// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"d0edded0","uploadButton":"ef7fe22a","imageContainer":"b2d18287","image":"dd158df3","input":"a9c69cd0","cancel":"c975abb7"};